module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/how_to_enjoy_photography_case2-f7927d0896cc41cc6cdf75eb66c039d5.png";